import { css } from 'emotion';
import getFontStyles from '../../../../lib/styles/getFontStyles';

export default function getStyles({ colors, fonts }) {
  return {
    allEpisodes: css({
      color: colors.headerSubtitleColor,
      ...getFontStyles(fonts.headerSubtitleFont, {
        fontSize: 14,
      }),
    }),
    prevNext: css({
      color: colors.contentDescriptionColor,
      ...getFontStyles(fonts.contentDescriptionFont, { fontSize: 14 }),
      '&:hover, &:active': {
        color: colors.linkColor,
      },
    }),
  };
}
